import { TableCard } from '../../../../components'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { ListViewProvider } from './core/ListViewProvider'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { AvaliacoesTable } from './table/AvaliacoesTable'
import { AvaliacoesListHeader } from './components/header/AvaliacoesListHeader'

const AvaliacoesList = () => {
  return (
    <TableCard>
      <AvaliacoesListHeader />
      <AvaliacoesTable />
    </TableCard>
  )
}

export const AvaliacoesListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <ListFiltersProvider>
          <AvaliacoesList />
        </ListFiltersProvider>
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
